import $ from 'jquery'

const $doc = $(document)

function ajaxLoadMoreNewsPosts(page) {
  const data = {
    page: page,
    action: 'ajax_news_loadmore',
  };

  $.ajax({
    url: php_vars.ajax_url,
    type: "POST",
    dataType: 'html',
    data,
    beforeSend: function () {
      $('body').find('.js-loadmore').text('Loading...').prop('disabled', true);
    },
    success: function (htmlResponse) {
      if (htmlResponse == "" || htmlResponse == null) {
        $('body').find('#ajaxPosts').html('<p class="no-results">No results found, please try a different combination of filters.</p>');
      }
      else {
        $('body').find('#ajaxPosts').append(htmlResponse);
      }
    },
    error: function () {
      $('body').find('#ajaxPosts').html('<p class="no-results">Sorry, no results found.</p>');
    },
    complete: function () {
      $('body').find('.js-loadmore').text('Load More').prop('disabled', false).attr('data-page', parseInt($('.js-loadmore').attr('data-page')) + 1);
      let currentPage = parseInt($('body').find('.js-loadmore').attr('data-page'));
      let maxPages = parseInt($('body').find('.js-loadmore').attr('data-max-pages'));
      if (currentPage > maxPages) {
        $('body').find('.js-loadmore').hide();
      }
    }
  });
}

export default function initNewsFunctions(){
  if ( $('body').hasClass('post-type-archive-news') ) {
    $doc.on('click', '.js-loadmore', function () {
      let page = $(this).attr('data-page');
      ajaxLoadMoreNewsPosts(page);
    });
  }
}
initNewsFunctions();
